import React, { useContext, useEffect, useMemo, useState } from "react";

import { AppBar, Toolbar, Typography } from "./styles/HeaderModule";
import { Badge, Grid, IconButton, Tooltip } from "@material-ui/core";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import SentimentExcitedIcon from "../../assets/svg/SentimentExcitedIcon";
import { PlayCircleOutline } from "@material-ui/icons";

const HeaderModule = ({
  title,
  bgcolor = "headercolor",
  textcolor = "black",
  fixed = "true",
  titleXs = 6,
  childXs = 6,
  font = "",
  videoId = null,
  receivedChild = null,
  ...props
}) => {
  const { queryParams } = useContext(QueryParamsContext);

  const [qyonfeedback, setQyonFeedback] = useState(null);
  const [feedbackCount, setFeedbackCount] = useState(0);
  const [qyonPlayer, setQyonPlayer] = useState(null);

  const feedbackReadyToUse = useMemo(
    () =>
      !!(
        queryParams?.usuario_id &&
        queryParams?.usuario_nome &&
        queryParams?.usuario_email &&
        process.env.REACT_APP_QYON_FEEDBACK_KEY
      ),
    [
      queryParams?.usuario_email,
      queryParams?.usuario_id,
      queryParams?.usuario_nome,
    ]
  );

  const playerReadyToUse = useMemo(
    () =>
      !!(
        queryParams?.usuario_id &&
        videoId &&
        process.env.REACT_APP_QYON_VIDEOS_KEY
      ),

    [queryParams?.usuario_id, videoId]
  );

  useEffect(() => {
    if (!feedbackReadyToUse) return;
    const feedback = new window.QyonFeedback({
      key: process.env.REACT_APP_QYON_FEEDBACK_KEY,
      user: {
        id: queryParams?.usuario_id,
        name: queryParams?.usuario_nome,
        email: queryParams?.usuario_email,
      },
    });
    setQyonFeedback(feedback);

    feedback.getCountFeedbackResponses((count) => {
      setFeedbackCount(count || 0);
    });
  }, [feedbackReadyToUse]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!playerReadyToUse) return;
    const player = new window.QyonEmbeddedPlayer({
      key: process.env.REACT_APP_QYON_VIDEOS_KEY,
      classId: videoId,
      userId: queryParams?.usuario_id,
      showChatbot: false,
    });

    setQyonPlayer(player);
  }, [playerReadyToUse]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AppBar bgcolor={bgcolor} textcolor={textcolor} fixed={fixed} {...props}>
      <Toolbar>
        <Grid container spacing={2}>
          <Grid item container xs={titleXs} alignItems="center">
            <Typography>{title}</Typography>
          </Grid>

          <Grid
            item
            xs={childXs}
            container
            justifyContent={"flex-end"}
            alignItems={"center"}
          >
            {receivedChild}

            {feedbackReadyToUse && (
              <Grid item>
                <Tooltip title="Dê seu feedback">
                  <IconButton
                    aria-label="info-qyon-feedback"
                    onClick={() => {
                      qyonfeedback.showFeedbackDialog();
                    }}
                  >
                    <Badge badgeContent={feedbackCount} color="primary">
                      <SentimentExcitedIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>
              </Grid>
            )}

            {playerReadyToUse && (
              <Grid item>
                <Tooltip title="Vídeo Treinamento">
                  <IconButton
                    aria-label="info-qyon-player"
                    onClick={() => {
                      qyonPlayer.showPlayerDialog();
                    }}
                  >
                    <PlayCircleOutline
                      style={{
                        fill: "#0047EE",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderModule;
